export interface IncomingGGGDTO {
  advertId?: string;
  ggg?: number;
}
